import { atom } from 'jotai';

import { Profile } from '../models/Profile';
import { ProfileOptions } from '../models/ProfileOptions';

interface ProfileWithOptions extends Profile, ProfileOptions {}

export const profileAtom = atom<ProfileWithOptions | null>(null);
